<ng-container *ngIf="employment$ | async as employment">
  <mat-icon
    svgIcon="suitcase-job"
    class="size-20 organisation-icon"></mat-icon>
  <div class="employment-department">
    {{ employment.department.name }}
  </div>
  <div class="employment-organisation">
    {{ employment.organisation.name }}
  </div>
</ng-container>
